var _jsxFileName = "/home/runner/work/frontend/frontend/libs/ui-design-system/src/assets/Features/FeatureBeen.tsx";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
function SvgComponent(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 1440 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 825 : _ref$height,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#E9F2F2' : _ref$color;
  return _jsx("svg", {
    width: width,
    height: height,
    viewBox: "0 0 ".concat(width, " ").concat(height),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: _jsx("path", {
      d: "M1644.8 128.808C1416.75 -72.2496 1172.1 -17.141 992.767 158.519C824.441 323.487 763.177 371.703 369.52 392.814C-24.1358 413.924 -116.479 635.629 -125.02 752.56C-136.056 904.146 -115.259 1177.86 405.367 1425.49C923.385 1671.89 1310.56 1636.95 1630.14 1158.04C1929.73 709.106 1839.49 300.476 1644.8 128.808Z",
      fill: color
    })
  });
}
var MemoSvgComponent = React.memo(SvgComponent);
export default MemoSvgComponent;
//# sourceMappingURL=FeatureBeen.js.map